export const FAQ_CONTENT = [
  {
    question: "Why would my landlord waive the security deposit?",
    answer:
      "Landlords take deposits to ensure timely rent payments & cover any damages to the property, we waive this concern by giving your landlord advance rent for the entire 10 months & 1 month of security deposit. Enabling Zero Deposit.",
  },
  {
    question: "What are the charges for tenants & landlords?",
    answer:
      "Tenants: 3-4% of Platform fees is added to their monthly rent. Landlords: get advance rent of the entire lease at a 3-4% discount.\n\nExample:\nMonthly Rent = ₹10,000/- & Lease = 10 months.\nFor landlord: Advance rent of entire lease: (₹10,000 x 11) - 4% discount fees = ₹1,05,600 + 1 Month's rent as Security deposit.\nFor tenant: Monthly rent as No-Cost EMI: ₹10,000 + 4% Platform fees = ₹10,400/-.",
  },
  {
    question: "How is my rent paid every month?",
    answer:
      "Your monthly rent is auto-deducted as a No-Cost EMI just like your Netflix subscription.",
  },
  {
    question: "Does rent as No-Cost EMI affect my credit score?",
    answer:
      "Yes, timely payments improve your credit score, while missed payments may lower it.",
  },
  {
    question: "Can I claim my HRA?",
    answer:
      "CirclePe has no role in this, you may request rent receipts from your landlord.",
  },
  {
    question: "What happens if I leave during the lock-in period?",
    answer:
      "You can find a new tenant to cover the remaining period or pay for the rest of the tenure.",
  },
  {
    question: "What is the rent agreement format?",
    answer:
      "It's a standard rent agreement with CirclePe included as facilitators, not a Master lease or Sub Lease.",
  },
  {
    question: "What is the process if I plan to vacate?",
    answer:
      "After the lock-in period, you extend a 30-day notice to CirclePe while making sure that the property is in the same condition as captured in the move-in report.",
  },
  {
    question: "Does the lease or lock-in period change?",
    answer:
      "The lease and lock-in period are the same, varying from 6 to 10 months.",
  },
  {
    question: "What are my obligations as a tenant?",
    answer:
      "You must complete your lock-in period & ensure that the property is in the same condition as captured in the move-in report.",
  },
];

export const landlordBenefits = [
  {
    title: "Get Advance Rent",
    description: "of the entire lease (Non-Refundable)",
    image: "/path-to-image-3.jpg",
  },

  {
    title: "We Find New Tenants",
    description: "on every renewal & save money on brokerage",
    image: "/path-to-image-5.jpg",
  },
  {
    title: "Normal Rent Agreement",
    description: "No master-lease/Sub-lease",
    image: "/path-to-image-6.jpg",
  },
  {
    title: "Move In & Move Out Report",
    description: "along with deep cleaning & full management",
    image: "/path-to-image-7.jpg",
  },
];

export const NCR_REGIONS = [
  "Delhi",
  "Gurugram",
  "Noida",
  "Faridabad",
  "Ghaziabad",
  "Others",
];

export const headingVariants = {
  hidden: {
    y: "100%",
    opacity: 0,
  },
  visible: {
    y: "0%",
    opacity: 1,
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

export const funFacts = [
  "Berlin has more museums than rainy days.",
  "In Paris, there are more pets than children! 🐾",
  "A day on Venus is longer than a year on Venus!",
  "It snows metal on Venus. Talk about a heavy blizzard!",
  'Scotland has 421 words for "snow". Let it snow, indeed!',
  "The world's quietest room is so silent it can drive you crazy in minutes. Located at Microsoft's headquarters.",
  "In Japan, there are vending machines that sell everything from live crabs to underwear. Only in Japan!",
  "There's a town in Norway where the sun doesn't set for 69 days straight. Talk about a long summer day.",
  "Canada has more lakes than the rest of the world combined. Lake life, eh?",
  "It's illegal to chew gum in Singapore. Better leave that bubble gum at home.",
  "There's a city in Turkey with houses carved into the side of a cliff. Talk about a room with a view!",
  "The entire country of Monaco is smaller than Central Park in New York City. Imagine the rent!",
  "There's a village in the Netherlands called Giethoorn that has no roads. All transportation is done by canals and footbridges. How peaceful!",
  "In Chefchaouen, Morocco, all the buildings are painted blue. It's a photographer's dream.",
  "The island of Yap uses giant stone discs as currency. Talk about heavy money!",
  "There's a lake in Australia that's naturally pink. (It's due to a specific type of algae.)",
  "Varanasi is one of the oldest continuously inhabited cities in the world. It's believed to be over 3,000 years old and is a major pilgrimage site for Hindus.",
  "The floating post office in Srinagar, Kashmir, is the only one of its kind in India. It's located on a houseboat on Dal Lake.",
  "Kolkata is home to the world's largest banyan tree. It's so big that it looks like a small forest!",
  "Chennai has the second-longest beach in the world, Marina Beach. It stretches for 13 kilometers along the Bay of Bengal.",
  'Hyderabad is known as the "City of Pearls" because it was once a major center for pearl trading. It\'s also famous for its biryani!',
];

export const CONSENT_MESSAGES = {
  SIGN_UP: "By continuing, I hereby agree to CirclePe's T&Cs and Privacy Policy & consent to be contacted by CirclePe & its partners via whatsapp, etc.",
  PAN_AND_BUREAU:
    "By Clicking Confirm, I allow CirclePe & it's partner to fetch my PAN, Credit Report & share with RBI regulated entities.",
  ADDRESS: "Use this as my correspondence address",
  FEXPRIME_INCOME: "I confirm that my household income is above ₹ 3,00,000/-",
  FEXPRIME:
    "I hereby apply the RENT FINANCING with Fexprime Finance Pvt. Ltd. (“FFPL”/ “Lender”) as per the details provided by me and I confirm to have read, understood and agreed to the PRODUCT DETAILS and other relevant APPLICATION TERMS.",
  CKYC: "I hereby authorize and give my consent to FFPL to download my KYC records from the Central KYC Registry (CKYCR) for the purpose of verification of my identity and address from the CKYCR database",
  BANKING:"By continuing, I hereby agree to AA Terms of Service and authorize FFPL to access my banking data via the RBI-licensed Account Aggregator network to assess credit eligibility",
  ESIGN: "I hereby confirm that I have read, understood / been explained in the language understood by me, the Loan Offer detailed in these Sanction Documents & Key Fact Statement (KFS) along with the Most Important Terms and Conditions (“MITC”), & I accord my consent to the same."
};

/**
 * Copy for the phone-mismatch recovery screen — the single place to edit this wording.
 *
 * The screen previously said only "Phone Number Mismatch" / "Don't worry, please provide the
 * phone number ending with X". That reads like a rejection and never explains WHY we are
 * asking, so customers had no idea what a "credit-file phone" was, whether they had been
 * declined, or what we would do with the number.
 *
 * These strings tell them the actual truth: credit bureaus hold a phone number against every
 * credit record, it is often an older one given to a bank years ago, nothing has been rejected,
 * their score is untouched, and the number is used only to locate the record.
 *
 * (The `heading` here intentionally overrides `screenConfig.heading`, which is duplicated 27
 * times across partnerJourney.jsx — one source of truth beats 27 copies to keep in sync.)
 */
export const ALT_PHONE_COPY = {
  heading: "Confirm your registered phone number",

  /**
   * One short sentence, not a paragraph. The numbers themselves are NOT repeated here — they
   * get their own card (`BureauNumbersCard`) so the customer can scan them instead of hunting
   * for five digits inside three lines of prose.
   */
  body:
    "Your credit record is registered against a different phone number — usually an older one you gave a bank or lender.",

  /**
   * Input placeholder. The field's config label is "Alt Phone", internal shorthand that was
   * leaking onto the screen as "Enter Your Alt Phone".
   *
   * Two variants because "the number shown above" is only true when the numbers card is
   * actually rendered — with no hints (~2% of cases) the card is hidden and that wording would
   * point at nothing.
   */
  inputPlaceholder: (hasHints) =>
    hasHints ? "Enter the number shown above" : "Enter your registered number",

  /** Fine print above the button, where the sibling screens already put their consent line. */
  reassurance:
    "This will not affect your credit score. We use this number only to find your credit record — we will not call or message it.",

  /** Inline error when the entered number matches none of the bureau's numbers. */
  mismatchError: (hints) =>
    `We could not match that number. Please try the one ending ${hints}.`,
};

export const FUN_FACT_MESSAGES = [
  "Honey never spoils! Archaeologists have found pots of honey in ancient Egyptian tombs that are over 3000 years old and still perfectly edible.",
  "Bananas are berries, but strawberries aren't! Botanically, a berry must have seeds and pulp inside, which bananas do, while strawberries don't.",
  "Octopuses have three hearts! Two pump blood to the gills, and one pumps it to the rest of the body. When they swim, the main heart actually stops!",
  "Wombat poop is cube-shaped! This helps it stay in place and not roll away, marking their territory more effectively.",
  "A day on Venus is longer than a year on Venus. It takes 243 Earth days to rotate once but only 225 Earth days to orbit the Sun!",
  "A single cloud can weigh over a million pounds! The water droplets in clouds add up to an immense weight.",
  "Sharks existed before trees! They've been around for over 400 million years, while trees evolved about 350 million years ago.",
  "The Eiffel Tower can grow taller in the summer. The metal expands in heat, making it up to 15 cm taller!",
  "Water can boil and freeze at the same time under the right conditions! This phenomenon is called the 'triple point.'",
  "Cows have best friends and can become stressed when separated. Their social bonds are very strong!",
  "There's enough gold inside Earth to coat the entire planet in a layer of gold about 1.5 feet thick!",
  "Sloths can hold their breath longer than dolphins. They slow their heart rate and can hold their breath for up to 40 minutes!",
  "Butterflies taste with their feet! Their taste sensors are located on their legs to help them identify food.",
  "Hot water freezes faster than cold water. This is called the Mpemba effect, though scientists still debate why it happens.",
  "Some turtles can breathe through their butts! This helps them stay underwater longer during hibernation.",
  "Your body has more bacterial cells than human cells. There are about 39 trillion bacteria compared to 30 trillion human cells!",
  "A bolt of lightning is five times hotter than the surface of the sun, reaching up to 30,000°C (54,000°F).",
  "There's a species of fungus that turns ants into 'zombies' by controlling their behavior before killing them.",
  "You can't hum while holding your nose closed. Try it—air needs to escape through your nose to create the sound!",
  "There are more stars in the universe than grains of sand on all Earth's beaches combined!",
  "The fingerprints of a koala are so similar to humans' that they can confuse forensic experts!",
  "It rains diamonds on Saturn and Jupiter due to the high pressure turning carbon into diamonds in their atmospheres!",
  "A flea can jump 350 times its body length—the equivalent of a human jumping the length of a football field!",
  "Cats can't taste sweetness. They lack the taste receptors for sugar, making them one of the few mammals without a sweet tooth!",
  "The largest volcano in the solar system, Olympus Mons, is on Mars. It's about three times taller than Mount Everest!",
  "The speed of a computer mouse is measured in 'Mickeys.' One Mickey is about 1/200th of an inch movement.",
  "Giraffes have the same number of neck bones as humans—just seven, but theirs are much longer!",
  "A group of flamingos is called a 'flamboyance'—a fitting name for such colorful birds!",
  "Venus is the only planet in the solar system that spins clockwise. All others rotate counterclockwise.",
];
